export function documentReady(cb: () => void): void {
    if (typeof cb !== 'function') {
        throw new TypeError('callback for documentReady must be a function');
    }

    function wrapCb() {
        document.removeEventListener('DOMContentLoaded', wrapCb, false);
        cb();
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        cb();
    } else {
        document.addEventListener('DOMContentLoaded', wrapCb, false);
    }
}
